import { createFileRoute } from '@tanstack/react-router';

import { QuizPage } from '@/pages/quiz';

type QuizSearchParams = {
  courseId: string;
  contentId: string;
  quizId: string;
};

export const Route = createFileRoute('/_user/courses/quiz')({
  validateSearch: (search: Record<string, string>): QuizSearchParams => {
    const courseId = search.courseId ?? '';
    const contentId = search.contentId ?? '';
    const quizId = search.quizId ?? '';

    return {
      courseId,
      contentId,
      quizId,
    };
  },
  component: QuizPage,
});
